import gsap from 'gsap';

// Animation
let defaultEase = "circ.inOut";

function headerAnimation() {
    setTimeout(() => {
        // Marquee
        let timeline = gsap.timeline();
        let sentenceWidth = document.querySelector('header .item-marquee .marquee-text').clientWidth;

        // Init timeline and register events.
        function init() {
            setTimeline();
            window.addEventListener('resize', handleResize);

            $(window).scroll(function () {
                if ($(this).scrollTop() > 100) {
                    timeline.pause()
                } else {
                    timeline.play()
                }
            });
        }

        // Add marquee animations to timeline.
        function setTimeline() {
            timeline
                .add(createMarquee(document.querySelector('header .item-marquee'), 'right'), 0)
        }

        // Create single marquee animation.
        function createMarquee(element, direction) {
            const distance = sentenceWidth * 2;
            return gsap.timeline()
                .to(element, {
                    duration: 20,
                    ease: 'none',
                    x: direction === 'left' ? distance : -distance,
                    onComplete() {
                        timeline.play(0);
                    },
                    onReverseComplete() {
                        timeline.reverse(0);
                    },
                },
                );
        }

        // Reset timeline on resize.
        function handleResize() {
            sentenceWidth = document.querySelector('header .item-marquee .marquee-text').clientWidth;
            timeline.seek(0);
            timeline.clear();
            setTimeline();
        }

        init();

        gsap.to("header .header-link > .line", {
            width: "100%",
            duration: 0.8,
            ease: defaultEase
        })

        gsap.to("header .header-link .link-item .item-row .item-marquee-container", {
            opacity: 1,
            duration: 0.8,
            delay: 0.1,
            ease: defaultEase
        })

        gsap.to("header .header-link .link-item .item-row .langauge a", {
            opacity: 1,
            x: 0,
            stagger: 0.1,
            delay: 0.2,
            duration: 0.8,
            ease: defaultEase
        })

        gsap.to("header .header-link .link-item:nth-child(3) > .line", {
            height: "100%",
            duration: 0.8,
            delay: 0.3,
            ease: defaultEase
        })

        gsap.to("header .header-link .link-item:nth-child(3) > a", {
            opacity: 1,
            x: 0,
            stagger: 0.1,
            delay: 0.3,
            duration: 0.8,
            ease: defaultEase
        })

        // Title
        gsap.to("header .header-title svg", {
            autoAlpha: 1,
            x: 0,
            duration: 0.8,
            ease: defaultEase
        })

        gsap.to("header .header-title > span", {
            autoAlpha: 1,
            x: 0,
            delay: 0.2,
            duration: 0.8,
            ease: defaultEase
        })

        // Logo
        gsap.to("header .header-logo", {
            autoAlpha: 1,
            duration: 0.6,
            ease: defaultEase
        })
    }, 500);
}

if ($(window).width() >= 1200) {
    headerAnimation();
}

$(window).resize(function () {
    if ($(window).width() >= 1200) {
        headerAnimation();
    }
});

function titleLink() {
    // Header Title Arrow Link
    if (document.referrer != '') {
        $("header .header-title .title-arrow").attr("href", document.referrer)
    } else {
        $("header .header-title .title-arrow").attr("href", "/")
    }
}

titleLink()

export { headerAnimation, titleLink }